import React from 'react';

const Kansas = () => (
  <svg
    width="99"
    height="53"
    viewBox="0 0 99 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.3"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M92.6562 5.75799C92.3957 6.18748 91.924 7.33516 91.6354 8.32088C91.3678 9.22915 91.8677 10.7218 90.6146 10.8838C91.0581 12.3976 91.3819 9.69386 92.6632 10.3698C92.5717 11.4893 93.0856 11.9962 94.198 11.9047C93.6348 15.3688 96.9859 14.9182 97.7814 17.0234C97.8448 28.7394 98.6262 39.7303 98.2953 51.8406C65.7347 53.291 32.4419 51.6505 0.514893 50.8197C1.23299 33.7878 1.87365 16.6855 3.07751 0.132324C19.5162 1.76581 37.8769 0.751925 55.2942 2.18123C60.7151 2.6248 66.9668 2.41357 72.1905 2.18123C78.231 1.91367 83.8208 0.801203 87.5451 1.66723C89.4529 2.11081 89.2558 2.20234 90.6146 3.71613C92.093 5.19472 92.9519 1.98408 93.1772 4.23013C94.0501 4.04002 94.1417 4.63146 94.198 5.25106C91.6002 4.51177 93.0364 5.01165 92.6562 5.75799Z"
      fill="#FC374D"
    />
  </svg>
);

export default Kansas;
